import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "hooks/translation-hooks";
import { event } from "analytics";
import { getFileSize } from "./collaborators/camera";
import { addErrorAlert } from "redux/actions/alertActions";
import { hideModal, showModal } from "redux/actions/modalActions";
import { setCamera } from "redux/actions/cameraActions";
import { removePicture, resetPictures } from "redux/actions/pictureActions";
import { pictureInfoSelector } from "redux/selectors/config";
import { selectCameraStatus } from "redux/selectors/camera";
import { isPicturesLoadingSelector } from "redux/selectors/picture";
import { uploadPicturesToCMX } from "../../../redux/actions/pictureActions";
import { useEffect } from "react";

const SIZE_ERROR_MESSAGE = "error_popup-picture_too_big";

export const usePicturesUploadRequired = () => {
  const dispatch = useDispatch();
  const { maximum_mb_size_of_picture } = useSelector(pictureInfoSelector);
  const isLoading = useSelector(isPicturesLoadingSelector);
  const isCameraOpen = useSelector(selectCameraStatus);
  const t = useTranslate();
  const successMessage = t("upload_photos_success-message");
  const errorMessage = t("upload_photos_error-message");
  const errorTitle = t("upload_photos_error-title");

  const discardPicture = ({ name }) => {
    dispatch(removePicture({ name }));
  };
  useEffect(() => () => dispatch(resetPictures()), [dispatch]);
  const onCameraClick = () => {
    dispatch(showModal({ type: "media" }));
    event("upload_now", "take_photos_incident");
  };

  const onTakePhoto = file => {
    const payload = {
      target: { files: [file] }
    };
    return payload;
  };
  const closeCamera = () => {
    dispatch(hideModal({ type: "media" }));
    dispatch(setCamera(false));
  };
  const handleImage = ({ target: { files } }) => {
    Array.from(files)
      .map(currentFile => ({
        name: currentFile.name,
        type: currentFile.type,
        uploadedAt: new Date(),
        size: getFileSize(currentFile.size),
        src: window.URL.createObjectURL(currentFile),
        status: "LOADED",
        currentFile
      }))
      .filter(picture => {
        if (picture.size < maximum_mb_size_of_picture) {
          return true;
        }
        dispatch(addErrorAlert(t(SIZE_ERROR_MESSAGE)));
        return false;
      })
      .forEach(picture => {
        const reader = new FileReader();
        reader.onload = e => {
          picture.src = e.target.result;
          dispatch(
            uploadPicturesToCMX({
              pictures: [picture],
              successMessage,
              errorMessage,
              errorTitle,
              refresher: () =>
                dispatch(
                  uploadPicturesToCMX({
                    pictures: [picture],
                    successMessage,
                    errorMessage,
                    errorTitle,
                    refresh: true
                  })
                )
            })
          );
        };
        reader.readAsDataURL(picture.currentFile);
      });
  };

  return {
    closeCamera,
    discardPicture,
    handleImage,
    onCameraClick,
    onTakePhoto,
    isCameraOpen,
    isLoading
  };
};
